import ReceiptLayoutV2 from './ReceiptLayoutV2';

export default function ReceiptPreviewModalV2({
  data,
  viewMode,
  onViewModeChange,
  onRevealCardNumber,
  sendMethod,
  onSendMethodChange,
  email,
  onEmailChange,
  phone,
  onPhoneChange,
  onSend,
  onClose,
  isSending,
  smsEnabled,
  kakaoEnabled,
}) {
  const sendDisabled = isSending || (sendMethod === 'sms' && !smsEnabled) || (sendMethod === 'kakao' && !kakaoEnabled);
  const sendLabel = isSending
    ? '전송중...'
    : (sendMethod === 'sms' && !smsEnabled) || (sendMethod === 'kakao' && !kakaoEnabled)
      ? '준비중'
      : sendMethod === 'kakao'
        ? '알림톡 전송'
        : sendMethod === 'sms'
          ? '문자 전송'
          : '이메일 전송';

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1000] overflow-y-auto py-5 px-3"
      onClick={() => { if (!isSending) onClose(); }}
    >
      <div
        className="bg-white border border-[#c7cdd3] w-full max-w-[400px] shadow-xl my-auto flex flex-col max-h-[92vh]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="overflow-y-auto flex-1 min-h-0">
          <ReceiptLayoutV2
            data={data}
            viewMode={viewMode}
            onViewModeChange={onViewModeChange}
            onRevealCardNumber={onRevealCardNumber}
          />
        </div>

        <div className="border-t border-[#d7dce0] p-4 bg-[#f7f8f9] shrink-0">
          <div className="flex overflow-hidden border border-[#d1d5db] mb-3">
            <button type="button" onClick={() => onSendMethodChange('email')} className={`flex-1 py-2 text-[12px] font-semibold ${sendMethod === 'email' ? 'bg-[#546673] text-white' : 'bg-white text-[#4e5968]'}`}>이메일</button>
            <button type="button" onClick={() => { if (smsEnabled) onSendMethodChange('sms'); }} className={`flex-1 py-2 text-[12px] font-semibold border-x border-[#d1d5db] ${!smsEnabled ? 'cursor-not-allowed text-[#adb5bd] bg-white' : sendMethod === 'sms' ? 'bg-[#00a58a] text-white' : 'bg-white text-[#4e5968]'}`}>{smsEnabled ? '문자' : '문자(준비중)'}</button>
            <button type="button" onClick={() => { if (kakaoEnabled) onSendMethodChange('kakao'); }} className={`flex-1 py-2 text-[12px] font-semibold ${!kakaoEnabled ? 'cursor-not-allowed text-[#adb5bd] bg-white' : sendMethod === 'kakao' ? 'bg-[#fee500] text-[#3c1e1e]' : 'bg-white text-[#4e5968]'}`}>{kakaoEnabled ? '카카오톡' : '카카오톡(준비중)'}</button>
          </div>

          {sendMethod === 'email' ? (
            <>
              <label className="block text-[12px] font-semibold text-[#4e5968] mb-1.5">이메일 주소</label>
              <input type="email" value={email} onChange={(event) => onEmailChange(event.target.value)} autoComplete="off" placeholder="example@email.com" onKeyDown={(event) => { if (event.key === 'Enter' && !isSending) onSend(); }} className="w-full mb-3 px-3 py-2 border border-[#d1d5db] text-[13px] outline-none focus:border-[#546673]" />
            </>
          ) : (
            <>
              <label className="block text-[12px] font-semibold text-[#4e5968] mb-1.5">휴대폰 번호</label>
              <input type="tel" value={phone} onChange={(event) => onPhoneChange(event.target.value)} placeholder="01012345678" onKeyDown={(event) => { if (event.key === 'Enter' && !isSending) onSend(); }} className="w-full mb-3 px-3 py-2 border border-[#d1d5db] text-[13px] outline-none focus:border-[#546673]" />
            </>
          )}

          <div className="flex gap-2">
            <button type="button" onClick={onClose} disabled={isSending} className="flex-1 px-3 py-2 text-[13px] font-semibold bg-[#e5e7eb] text-[#111827] disabled:cursor-not-allowed">닫기</button>
            <button type="button" onClick={onSend} disabled={sendDisabled} className={`flex-1 px-3 py-2 text-[13px] font-semibold ${sendDisabled ? 'bg-[#d1d5db] text-[#8b95a1] cursor-not-allowed' : sendMethod === 'kakao' ? 'bg-[#fee500] text-[#3c1e1e]' : sendMethod === 'sms' ? 'bg-[#00a58a] text-white' : 'bg-[#546673] text-white'}`}>{sendLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

